import { getParameterFromURL } from './getParameterFromUrl';
import { FirstScreen, getFirstScreenFromURL } from './firstScreen';

type OnboardingType = 'general' | 'puppy_blues' | 'crate' | 'new_puppy' | 'play_games' | 'biting'| 'potty' | 'k9';

type OnboardingAnswers = {
  questionary: {
    role?: string;
    onboarding_type?: OnboardingType;
  };
} | null;

const ONBOARDING_TYPE_BY_CONFIG: Record<string, OnboardingType> = {
  customV2: 'general',
  customV54: 'general',
  customV56: 'puppy_blues',
  customV58: 'crate',
  customV59: 'play_games',
  customV61: 'crate',
  customV62: 'new_puppy',
  customV63: 'puppy_blues',
  customV64: 'biting',
  customV67: 'puppy_blues',
  customV68: 'puppy_blues',
  customV69: 'potty',
  customV70: 'potty',
  customV71: 'potty',
  customV76: 'k9',
  customV78: 'k9',
  customV79: 'k9',
};

// Funnels that pick their first screen from the creative tag report the theme the
// user actually saw instead of a single per-config type.
const ONBOARDING_TYPE_BY_FIRST_SCREEN: Record<FirstScreen, OnboardingType> = {
  general: 'general',
  stop_biting: 'biting',
  crate_training: 'crate',
  potty_training: 'potty',
};

const CONFIGS_WITH_THEMED_FIRST_SCREEN = new Set(['customV77']);

export const getOnboardingTypeByConfig = (
  config: string | null,
  firstScreen?: FirstScreen | null,
): OnboardingType => {
  if (firstScreen && CONFIGS_WITH_THEMED_FIRST_SCREEN.has(config ?? '')) {
    return ONBOARDING_TYPE_BY_FIRST_SCREEN[firstScreen];
  }

  return ONBOARDING_TYPE_BY_CONFIG[config ?? ''] ?? 'general';
};

export const getOnboardingAnswersFromURL = (url?: string): OnboardingAnswers => {
  const role = getParameterFromURL('role', url);
  const onboardingType = getOnboardingTypeByConfig(
    getParameterFromURL('config', url),
    getFirstScreenFromURL(url),
  );

  return {
    questionary: {
      ...(role && { role }),
      onboarding_type: onboardingType,
    },
  };
};
